module.exports = __webpack_public_path__ + "static/img/pc-1.f549ab2e.png";